import React from 'react';
import './ReactTable.scss';

const Table = (props) => {
  const { tableInstance, onClickSortOption, sortOption, isMultiSortable, emptyText } = props;
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

  const getClassNameBySortedStatus = (sortOption, columnId) => {
    const sortedColumns = sortOption?.sort ? sortOption.sort.split(',') : [];

    const isSortedAsc = sortedColumns.includes(columnId);
    const isSortedDesc = sortedColumns.includes(`-${columnId}`);
    const isSortNone = !isSortedAsc && !isSortedDesc;

    if (isSortNone) return 'sort-none';
    if (isSortedDesc) return 'sort-desc';
    if (isSortedAsc) return 'sort-asc';
    return '';
  };

  return (
    <>
      <table className="rt-table" {...getTableProps}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                return (
                  <th
                    {...column.getHeaderProps()}
                    key={column.id}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={column.canSort ? getClassNameBySortedStatus(sortOption, column.id) : ''}
                    onClick={() => column.canSort && onClickSortOption(column.id, isMultiSortable)}
                  >
                    {column.render('Header')}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <thead className="column-filter">
          {headerGroups.map((headerGroup) => (
            <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th key={column.id} {...column.getHeaderProps()}>
                  <span>{column.canFilter ? column.render('Filter') : null}</span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row) => {
              prepareRow(row);
              return (
                <tr key={row.id} {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td key={cell.id} {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={headerGroups[0].headers.length}>{emptyText}</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default Table;
